import React from 'react';
import useMain from '../../../hooks/useMain';
import MyPackagesTable from './myPackagesDeps/myPackagesTable';
import { capitalize } from 'lodash';
import { number } from 'prop-types';
import { numberWithCommas } from '../../../utils/helpers';
import Image from './../../common/image';

const MyPackages = () => {
	const { userData } = useMain();
	const { class: userClass, userCards, maxCap, MMIMaxCap, mmi, totalCardsUsedMaxCap } = userData;
	console.log('userData :>> ', userData);
	return (
		<div className='mb-4 card myCards'>
			<div className='card-body'>
				<div className='row gy-4 my-4 text-center'>
					<div className='col-12'>
						<div className='fw-bold fs-2'>My Packages</div>
					</div>
					<div className='offset-md-2 col-md-8 col-12 alert alert-secondary text-center'>
						<div className='centerAll'>
							<div className='me-3'>
								Class: <span className='fw-bold'>{capitalize(userClass)}</span>
							</div>
						</div>
						<hr />
						<div className='centerAll'>
							<Image
								height='40px'
								fileName={`diamonds/mmi_${mmi.isActive}.webp`}
							/>
							<div className='mx-3'>
								MMI:{' '}
								<span className='fw-bold'>Is {!mmi.isActive && 'Not '}Active</span>
							</div>
							<div>
								MMI Bonus Max Cap:{' '}
								<span className='fw-bold'>
									${numberWithCommas(MMIMaxCap / 1e6)}
								</span>
							</div>
						</div>
						<hr />
						<div className='centerAll'>
							<div>
								Total MaxCap:{' '}
								<span className='fw-bold'>${numberWithCommas(maxCap / 1e6)}</span>
							</div>
							<div className='mx-3'>
								Total Used MaxCap:{' '}
								<span className='fw-bold'>
									${numberWithCommas(totalCardsUsedMaxCap / 1e6)}
								</span>
							</div>
							<div>
								Remaining MaxCap:{' '}
								<span className='fw-bold'>
									${numberWithCommas((maxCap - totalCardsUsedMaxCap) / 1e6)}
								</span>
							</div>
						</div>
					</div>
					<div className='col-12'>
						<div className='fw-bold fs-5'>My Cards Table</div>
					</div>
					<div className='offset-md-2 col-md-8 col-12'>
						<MyPackagesTable
							cards={userCards}
							userClass={userClass}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MyPackages;
